/**
 * JWT Decoder Utility
 * Decodes JWT tokens to extract user information
 */
/**
 * Decode JWT token without verification (client-side only)
 * Note: This does NOT verify the token signature - only decodes the payload
 * For production, tokens should be verified on the backend
 */
export function decodeJWT(token) {
    try {
        // JWT format: header.payload.signature
        const parts = token.split('.');
        if (parts.length !== 3) {
            throw new Error('Invalid JWT format');
        }
        // Decode base64url encoded payload
        const payload = parts[1];
        if (!payload) {
            throw new Error('Missing JWT payload');
        }
        const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64)
            .split('')
            .map((c) => {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
            .join(''));
        return JSON.parse(jsonPayload);
    }
    catch (error) {
        console.error('Failed to decode JWT:', error);
        return null;
    }
}
/**
 * Extract user information from ID token
 */
export function extractUserFromIdToken(idToken) {
    const decoded = decodeJWT(idToken);
    if (!decoded) {
        return null;
    }
    // Extract user information
    const email = decoded.email || decoded.preferred_username || '';
    const name = decoded.name ||
        [decoded.given_name, decoded.family_name].filter(Boolean).join(' ') ||
        email.split('@')[0] ||
        'User';
    const username = decoded.preferred_username || decoded.email || decoded.sub;
    const id = decoded.sub || '';
    if (!id || !email) {
        return null;
    }
    // Extract Cognito groups from token
    const groups = decoded['cognito:groups'] || [];
    return {
        id,
        email,
        name,
        username,
        groups: Array.isArray(groups) ? groups : [],
    };
}
//# sourceMappingURL=jwt-decoder.js.map